/* Mega menu: open on hover (desktop only) */
if (window.matchMedia('(min-width: 990px)').matches) {
  document.querySelectorAll('header-menu').forEach(menu => {
    const details = menu.querySelector('details');
    if (!details) return;
    let timer;
    menu.addEventListener('mouseenter', () => {
      clearTimeout(timer);
      details.setAttribute('open', '');
    });
    menu.addEventListener('mouseleave', () => {
      timer = setTimeout(() => details.removeAttribute('open'), 150);
    });
  });
}
